<app-base-photo
  [mode]="mode"
  [text]="text"
  [newPhoto]="newPhoto"
  [photoSrc]="photoUrl"
  [showPreview]="showPreview"
  [size]="size"
  [width]="width"
  [height]="height"
  [borderRadius]="borderRadius"
  [rounded]="rounded"
  [tuiSkeleton]="loading"
  [loading]="loading"
  (photoChange)="photoChange.emit($event)"
  (photoDelete)="onPhotoDelete()"
  (openPreviewDialog)="openPreviewDialog()"
></app-base-photo>
